import { UPDATE_SERVICE_WORKER } from './action-types';

export const updateServiceWorker = () => ({
  type: UPDATE_SERVICE_WORKER,
});
